'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _url = require('url');

var _url2 = _interopRequireDefault(_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BreadCrumb(props) {
  var items = props.items,
      location = props.location,
      id = props.id;


  return _react2.default.createElement(
    'div',
    { id: id || 'subheader' },
    _react2.default.createElement(
      'div',
      { className: 'nav-primary' },
      _react2.default.createElement(
        'ol',
        { className: 'breadcrumb' },
        items.length ? items.map(function (item, index) {
          return _react2.default.createElement(
            'li',
            { key: item.text + '-' + item.pageUrl },

            // The last element is displayed as text, otherwise linkages
            index < items.length - 1 ? _react2.default.createElement(
              _reactRouter.Link,
              {
                to: (0, _extends3.default)({}, location, {
                  pathname: _url2.default.parse(item.pageUrl).pathname,
                  query: (0, _extends3.default)({}, location.query, { offset: 0 })
                })
              },
              item.text
            ) : item.text
          );
        }) : null
      )
    )
  );
} // BreadCrumb

BreadCrumb.propTypes = {
  items: _react.PropTypes.array.isRequired,
  location: _react.PropTypes.object.isRequired,
  id: _react.PropTypes.string
};

exports.default = BreadCrumb;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/BreadCrumb.js
// module id = 278
// module chunks = 0